var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    staticClass: "d-flex align-items-center justify-content-center px-0",
    class: _vm.isMobile ? 'py-2' : 'py-3',
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "w-100 d-flex align-items-center justify-content-between"
  }, [_c('h4', {
    staticClass: "mb-0",
    class: _vm.isMobile ? 'h6' : 'h4'
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', [(_vm.displayAddUser) ? _c('AddUserIcon') : _vm._e(), _vm._v(" "), (_vm.displayBulkUpload) ? _c('BulkUploadIcon') : _vm._e(), _vm._v(" "), (_vm.displayBack) ? _c('p', {
    staticClass: "text-primary",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Back")]) : _vm._e()], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5467dd47","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/Layout/TopBar.vue
// module id = FyUo
// module chunks = 2